import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError } from "redux-form";
import { compose, withHandlers, withState } from "recompose";
import { forEach } from "lodash";
import Button from "react-md/lib/Buttons/Button";

import TextField from "../form/TextField";
import AutocompleteField from "../form/AutocompleteField";
import * as Validation from "../form/Validation";

import { setActiveForm } from "../../actions/appActions";
import {
  addUserResourceRights,
  getUserResourcesRights
} from "../../actions/resourceActions";
import { getUsers } from "../../actions/userActions";

const Form = ({
  handleSubmit,
  history,
  setActiveForm,
  users,
  getUsers,
  setAutocompleteContent
}) => {
  const optionsAutocomplete = [];
  if (users)
    forEach(users, item =>
      optionsAutocomplete.push({
        label: item.name,
        value: item.id
      })
    );

  return (
    <form onSubmit={handleSubmit}>
      <Field
        component={AutocompleteField}
        label="Email"
        name="id"
        data={optionsAutocomplete}
        onChange={(e, value) => getUsers(value)}
        onAutocomplete={value => setAutocompleteContent(value)}
        validate={[Validation.required]}
      />
      <Field
        component={TextField}
        label="Práva"
        name="rights"
        validate={[Validation.required]}
      />
      <div className="flex-row flex-right">
        <Button
          flat
          label="Zrušit"
          className="btn"
          onClick={() => setActiveForm(null)}
        />
        <Button
          flat
          primary
          label="Přidat"
          type="submit"
          className="btn btn-primary"
        />
      </div>
    </form>
  );
};

export default compose(
  connect(({ resource: { users } }) => ({ users }), {
    setActiveForm,
    addUserResourceRights,
    getUsers,
    getUserResourcesRights
  }),
  withState("autocompleteContent", "setAutocompleteContent", ""),
  withHandlers({
    onSubmit: () => async (formData, dispatch, props) => {
      const {
        setActiveForm,
        autocompleteContent,
        addUserResourceRights,
        resource,
        getUserResourcesRights
      } = props;
      const { rights } = formData;

      if (autocompleteContent === "") {
        throw new SubmissionError({
          id: "Povinné"
        });
      }

      if (
        await addUserResourceRights({
          user: { id: autocompleteContent },
          resource: { id: resource.id },
          rights
        })
      ) {
        getUserResourcesRights(resource.id);
        setActiveForm(null);
      } else
        throw new SubmissionError({
          rights: "Přidání se nezdařilo"
        });
    }
  }),
  reduxForm({ form: "adminResourcesAddUserResourceRightsForm" })
)(Form);



// WEBPACK FOOTER //
// ./src/components/resource/AddRightsForm.js